import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import PDFHealthComponent from "../../components/pdfHealth/PDFHealthComponent";

const PDFHealth = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <PDFHealthComponent />
                </div>
            </div>
        </div>
    );
};

export default PDFHealth;
